<div class="mt-6 mb-5 d-flex justify-content-center">
  <section class="container-fluid pb-4">
    <div class="row justify-content-laptop-center">
      <div class="col">
        <app-showcases-container [entity]="entity"></app-showcases-container>
      </div>
    </div>
  </section>
</div>
